"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressiveAssignments_exports = {};
__export(ProgressiveAssignments_exports, {
  default: () => ProgressiveAssignments_default
});
module.exports = __toCommonJS(ProgressiveAssignments_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.06757 8.94687C5.06757 6.20754 7.28823 3.98687 10.0276 3.98687H29.8676C32.6069 3.98687 34.8276 6.20754 34.8276 8.94687V34.9869C34.8276 37.7262 32.6069 39.9469 29.8676 39.9469H10.0276C7.28823 39.9469 5.06757 37.7262 5.06757 34.9869L5.06757 8.94687Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.2515 2.74711C13.2515 2.33621 12.9184 2.00311 12.5075 2.00311C12.0966 2.00311 11.7635 2.33621 11.7635 2.74711V3.98723L10.0276 3.98687C7.28823 3.98687 5.06757 6.20754 5.06757 8.94687L5.06757 34.9869C5.06757 37.7262 7.28823 39.9469 10.0276 39.9469H29.8676C32.6069 39.9469 34.8276 37.7262 34.8276 34.9869V8.94687C34.8276 6.20754 32.6069 3.98687 29.8676 3.98687L28.1315 3.98723V2.74711C28.1315 2.33621 27.7984 2.00311 27.3875 2.00311C26.9766 2.00311 26.6435 2.33621 26.6435 2.74711V3.98723H20.6915V2.74711C20.6915 2.33621 20.3584 2.00311 19.9475 2.00311C19.5366 2.00311 19.2035 2.33621 19.2035 2.74711V3.98723H13.2515V2.74711ZM11.7635 5.47523V6.46711C11.7635 6.87801 12.0966 7.21111 12.5075 7.21111C12.9184 7.21111 13.2515 6.87801 13.2515 6.46711V5.47523H19.2035V6.46711C19.2035 6.87801 19.5366 7.21111 19.9475 7.21111C20.3584 7.21111 20.6915 6.87801 20.6915 6.46711V5.47523H26.6435V6.46711C26.6435 6.87801 26.9766 7.21111 27.3875 7.21111C27.7984 7.21111 28.1315 6.87801 28.1315 6.46711V5.47523H29.8676C31.7851 5.47523 33.3396 7.0297 33.3396 8.94723V34.9872C33.3396 36.9048 31.7851 38.4592 29.8676 38.4592H10.0276C8.11003 38.4592 6.55557 36.9048 6.55557 34.9872V8.94723C6.55557 7.0297 8.11003 5.47523 10.0276 5.47523H11.7635Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.2836 16.387C9.2836 16.7979 9.6167 17.131 10.0276 17.131H18.7076C19.1185 17.131 19.4516 16.7979 19.4516 16.387C19.4516 15.9761 19.1185 15.643 18.7076 15.643H10.0276C9.6167 15.643 9.2836 15.9761 9.2836 16.387Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.2836 23.827C9.2836 23.4161 9.6167 23.083 10.0276 23.083H29.8676C30.2785 23.083 30.6116 23.4161 30.6116 23.827C30.6116 24.2379 30.2785 24.571 29.8676 24.571H10.0276C9.6167 24.571 9.2836 24.2379 9.2836 23.827Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0276 30.523C9.6167 30.523 9.2836 30.8561 9.2836 31.267C9.2836 31.6779 9.6167 32.011 10.0276 32.011H29.8676C30.2785 32.011 30.6116 31.6779 30.6116 31.267C30.6116 30.8561 30.2785 30.523 29.8676 30.523H10.0276Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.2845 26.1428L35.5235 10.9038C35.5768 10.8505 35.5768 10.7642 35.5235 10.7109L31.8584 7.04584C31.8052 6.99257 31.7188 6.99257 31.6655 7.04584L16.4265 22.2848C16.3733 22.3381 16.3733 22.4245 16.4265 22.4777L20.0916 26.1428C20.1449 26.1961 20.2312 26.1961 20.2845 26.1428Z",
      fill: "#407177"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M35.7164 10.7109L37.4525 8.97483C37.5058 8.92156 37.5058 8.8352 37.4525 8.78193L33.7874 5.11685C33.7341 5.06359 33.6478 5.06359 33.5945 5.11685L31.8584 6.85294C31.8052 6.90621 31.8052 6.99257 31.8584 7.04584L35.5235 10.7109C35.5768 10.7642 35.6631 10.7642 35.7164 10.7109Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.4645 28.2791L19.9849 26.3117C20.0792 26.278 20.1064 26.1576 20.0355 26.0867L16.4826 22.5338C16.4118 22.463 16.2913 22.4901 16.2577 22.5845L14.2902 28.1048C14.2516 28.2132 14.3562 28.3177 14.4645 28.2791Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M38.5134 7.91388L37.6454 8.78193C37.5921 8.8352 37.5058 8.8352 37.4525 8.78193L33.7874 5.11685C33.7341 5.06359 33.7341 4.97722 33.7874 4.92395L34.6555 4.05591C35.7208 2.99056 37.4481 2.99056 38.5134 4.05591C39.5788 5.12126 39.5788 6.84853 38.5134 7.91388Z",
      fill: "#D16D37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.2171 3.61764C35.5245 2.31017 37.6444 2.31017 38.9518 3.61765C40.2593 4.92512 40.2593 7.04496 38.9518 8.35243L20.645 26.6592C20.577 26.7273 20.4966 26.7817 20.4081 26.8196L13.9943 29.5684C13.3667 29.8374 12.7321 29.2028 13.0011 28.5752L15.7499 22.1613C15.7878 22.0729 15.8422 21.9925 15.9103 21.9244L34.2171 3.61764ZM38.075 4.49446C37.2518 3.67123 35.9171 3.67123 35.0939 4.49446L34.5678 5.02056L37.5489 8.00172L38.075 7.47562C38.8983 6.6524 38.8983 5.31768 38.075 4.49446ZM32.6387 6.94958L33.691 5.89737L36.6721 8.87854L35.6199 9.93075L32.6387 6.94958ZM31.7619 7.8264L17.2069 22.3815L20.188 25.3626L34.7431 10.8076L31.7619 7.8264ZM15.3292 26.2908L16.5392 23.4674L19.1021 26.0303L16.2787 27.2403L15.3292 26.2908Z",
      fill: "currentColor"
    }
  )
);
const SvgProgressiveAssignments = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ProgressiveAssignments_default = SvgProgressiveAssignments;
